import _history from "routing/history"

export const DONATION_HISTORY_SUFFIX = "donationHistory"

export const suffixes = [
  DONATION_HISTORY_SUFFIX,
  "profile",
  "privacy",
  "classNote",
  "filters",
  "task",
  "userTask",
  "userJobPost",
  "organizationProfile",
]

export const addSuffix = (suffix) => {
  let { pathname } = _history.location
  const suffixValid = suffixes.indexOf(suffix) !== -1
  const noSuffixesPresent = !suffixes.some((x) => pathname.endsWith(x))

  if (suffixValid && noSuffixesPresent) {
    if (!pathname.endsWith("/")) {
      pathname += "/"
    }
    _history.push({ ..._history.location, pathname: pathname + suffix })
  }
}

export const suffixesWithSlashes = suffixes.map((x) => "/".concat(x))
